(() => {
  // Style previews are available immediately; hover is enhancement, never the loading trigger.
  document.querySelectorAll('.style-card .style-photo img,.route-style-card img').forEach(img => {
    img.style.opacity = '1';
    img.style.visibility = 'visible';
    if (img.decode) img.decode().catch(()=>{});
  });
})();
(() => {
  'use strict';

  /* Resolve canonical-looking links before navigation when the real Shopify
     resource is not created yet. This removes the 404 flash without locking
     the theme to legacy search routes. */
  let resolved = {};
  try {
    resolved = JSON.parse(document.getElementById('SVResolvedRoutes')?.textContent || '{}');
  } catch (_) {}

  const resolveHref = raw => {
    if (!raw || !resolved) return raw;
    try {
      const original = new URL(raw, location.origin);
      if (original.origin !== location.origin) return raw;
      const targetRaw = resolved[original.pathname.replace(/\/+$/,'')];
      if (!targetRaw) return raw;
      const target = new URL(targetRaw, location.origin);
      if (target.pathname === original.pathname && target.search === original.search) return raw;
      original.searchParams.forEach((value,key) => {
        if (key !== 'q' && !target.searchParams.has(key)) target.searchParams.append(key,value);
      });
      if (original.hash) target.hash = original.hash;
      return target.pathname + target.search + target.hash;
    } catch (_) { return raw; }
  };

  document.querySelectorAll('a[href^="/"]').forEach(anchor => {
    const next = resolveHref(anchor.getAttribute('href'));
    if (next && next !== anchor.getAttribute('href')) anchor.setAttribute('href', next);
  });

  /* Shared keyboard quality for search suggestions. */
  document.querySelectorAll('[data-sv-live-search]').forEach(form => {
    const input = form.querySelector('input[type="search"]');
    const results = form.querySelector('[data-live-results]');
    if (!input || !results) return;
    input.addEventListener('keydown', event => {
      if (!['ArrowDown','ArrowUp'].includes(event.key)) return;
      const items = [...results.querySelectorAll('a,button')].filter(el => el.offsetParent !== null);
      if (!items.length) return;
      event.preventDefault();
      (event.key === 'ArrowDown' ? items[0] : items[items.length - 1]).focus();
    });
    results.addEventListener('keydown', event => {
      if (!['ArrowDown','ArrowUp'].includes(event.key)) return;
      const items = [...results.querySelectorAll('a,button')].filter(el => el.offsetParent !== null);
      const index = items.indexOf(document.activeElement);
      if (index < 0) return;
      event.preventDefault();
      const dir = event.key === 'ArrowDown' ? 1 : -1;
      const next = items[(index + dir + items.length) % items.length];
      next?.focus();
    });
  });

  /* Focus containment / focus return for the site's main drawers and modals. */
  const focusable = 'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),summary,[tabindex]:not([tabindex="-1"])';
  const configs = [
    {root:'[data-search-overlay]', triggers:'[data-search-open]', open:r=>!r.hidden},
    {root:'[data-cart-drawer]', triggers:'[data-cart-drawer-open]', open:r=>!r.hidden},
    {root:'[data-shopify-filter-panel]', triggers:'[data-filter-toggle]', open:r=>!r.hidden},
    {root:'[data-fit-modal]', triggers:'[data-fit-open]', open:r=>!r.hidden},
    {root:'[data-mobile-menu]', triggers:'[data-mobile-menu-open]', open:r=>r.classList.contains('open')}
  ];

  configs.forEach(cfg => {
    const root = document.querySelector(cfg.root);
    if (!root) return;
    let returnFocus = null;
    document.querySelectorAll(cfg.triggers).forEach(trigger => trigger.addEventListener('click', () => { returnFocus = trigger; }, true));
    root.addEventListener('keydown', event => {
      if (event.key !== 'Tab' || !cfg.open(root)) return;
      const nodes = [...root.querySelectorAll(focusable)].filter(el => el.offsetParent !== null);
      if (!nodes.length) return;
      const first = nodes[0], last = nodes[nodes.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    });
    const closeSelectors='[data-search-close],[data-cart-drawer-close],[data-filter-panel-close],[data-fit-close],[data-mobile-menu-close]';
    root.querySelectorAll(closeSelectors).forEach(btn => btn.addEventListener('click', () => setTimeout(()=>returnFocus?.focus?.(),0)));
  });

  /* Prevent dialog stacks from leaving page scrolling locked or unlocked incorrectly. */
  const syncDialogLock = () => {
    const anyOpen =
      !!document.querySelector('[data-search-overlay]:not([hidden])') ||
      !!document.querySelector('[data-cart-drawer]:not([hidden])') ||
      !!document.querySelector('[data-shopify-filter-panel]:not([hidden])') ||
      !!document.querySelector('[data-fit-modal]:not([hidden])') ||
      !!document.querySelector('[data-sv-lens-drawer].is-open') ||
      !!document.querySelector('[data-mobile-menu].open');
    document.documentElement.classList.toggle('sv-dialog-open', anyOpen);
    document.body.classList.toggle('sv-dialog-open', anyOpen);
  };
  const observer = new MutationObserver(syncDialogLock);
  document.querySelectorAll('[data-search-overlay],[data-cart-drawer],[data-shopify-filter-panel],[data-fit-modal],[data-sv-lens-drawer],[data-mobile-menu]').forEach(el => observer.observe(el,{attributes:true,attributeFilter:['hidden','class','aria-hidden']}));
  syncDialogLock();

  /* Progressive image decoding for visible catalogue images without promoting
     every below-the-fold asset to eager loading. */
  if ('requestIdleCallback' in window) {
    requestIdleCallback(() => {
      document.querySelectorAll('.product-card img[loading="lazy"],.sv-accessory-family-card img[loading="lazy"]').forEach(img => img.decode?.().catch(()=>{}));
    }, {timeout:1800});
  }
})();


(() => {
  // 5.5 — +N expands the remaining family colours in place; it never opens the PDP.
  let i18n = {};
  try { i18n = JSON.parse(document.getElementById('SVTranslations')?.textContent || '{}'); } catch (_) {}
  document.querySelectorAll('[data-swatches-more]').forEach(button => {
    const compactLabel = button.textContent.trim();
    button.addEventListener('click', event => {
      event.preventDefault();
      event.stopPropagation();
      const group = button.closest('.sv-card-swatches');
      if (!group) return;
      const willExpand = button.getAttribute('aria-expanded') !== 'true';
      group.querySelectorAll('[data-swatch-extra]').forEach(swatch => { swatch.hidden = !willExpand; });
      button.setAttribute('aria-expanded', willExpand ? 'true' : 'false');
      button.textContent = willExpand ? '−' : compactLabel;
      button.setAttribute('aria-label', willExpand ? (i18n.hide_extra_colors || 'Hide additional colours') : (i18n.show_all_colors || 'Show all colours'));
    });
  });
})();

(() => {
  // 5.7 — optional invoice details on the cart. Cart attributes travel with the order.
  const toggle = document.querySelector('[data-invoice-toggle]');
  const details = document.querySelector('[data-invoice-details]');
  if (!toggle || !details) return;
  const sync = () => { details.hidden = !toggle.checked; };
  toggle.addEventListener('change', sync);
  sync();
})();
